import { Flex, Title, Text } from "@mantine/core";
import {
  ENUMPOASteps,
  usePOAStepsStore,
} from "../../../hooks/ui/poaStepsDataStore";
import { useUpdateCustomerPOAData } from "../../../hooks/ui/customerPOADataStore";
import { useEffect } from "react";
import { useCreateBooking } from "../../../hooks/api/useCreateBooking";
import { getRouteApi } from "@tanstack/react-router";

const routeApi = getRouteApi("/signup/");

export default function AdvisoryBooking() {
  const params = routeApi.useSearch();

  const { customerPOAData, updateBooking } = useUpdateCustomerPOAData();
  const { setStep } = usePOAStepsStore();
  const createBooking = useCreateBooking();
  const agentId = params.agent_id;

  const checkBookingMessage = (e: MessageEvent) => {
    if (e.origin === "https://sambla-pension.youcanbook.me") {
      if (e.data?.message?.data === "/thanks") {
        setStep(ENUMPOASteps.POASUMMARY);
      }
    }
  };

  useEffect(() => {
    window.addEventListener("message", (e) => checkBookingMessage(e));
    createBooking.mutate(
      { agentId, credentials: customerPOAData.credentials },
      {
        onSuccess: (data) => {
          updateBooking(data);
        },
      }
    );

    return () => {
      window.removeEventListener("message", (e) => checkBookingMessage(e));
    };
  }, []);

  return (
    <Flex justify="center" align="center" p={"xl"}>
      <Flex direction="column" maw={672} w={"100%"}>
        <Title order={2} mb="1rem" ff="var(--wallet-font-family-subjecttivity)">
          När vill du att vi ringer dig för rådgivning?
        </Title>
        <Text mb="1rem">
          När vi har analyserat din pension kontaktar vi dig för ett
          kostnadsfritt rådgivningssamtal. Vi går tillsammans igenom din pension
          och ser över hur du kan förbättra ditt sparande utifrån dina behov och
          mål.
        </Text>
        <iframe
          title="YoucanBookMe"
          style={{
            height: "80vh",
            width: "100%",
            border: "none",
          }}
          src={`${import.meta.env.VITE_YCBM_URL}/?EMAIL=${customerPOAData.email}&FNAME=${customerPOAData.firstName}&LNAME=${customerPOAData.lastName}&TREF=${createBooking.data?.bookingId}`}
        ></iframe>
      </Flex>
    </Flex>
  );
}
